import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'

import { ThemeProvider, useTheme } from 'styled-components'

import { Footer, MerchantHeader } from '@reveni-io/reveni-ui'

import AppContext from '@/context/AppContext'
import { getTheme } from '@/helpers'

import * as Styles from './styles'

const PageLayout = () => {
  const theme = useTheme()
  const { context } = useContext(AppContext)
  const { t } = useTranslation()

  const portalTheme = context?.merchantInfo?.theme

  return (
    <ThemeProvider theme={getTheme(theme, portalTheme)}>
      <Styles.ContentContainer
        background={context.merchantInfo?.theme?.returns_background_url}
        backgroundMobile={context.merchantInfo?.theme?.returns_background_mobile_url}
      >
        <MerchantHeader
          coverUrl={context?.merchantInfo?.theme?.returns_cover_url}
          logoUrl={context?.merchantInfo?.theme?.logo_url}
          storeName={context?.merchantInfo?.name}
          storeUrl={context?.merchantInfo?.domain}
          descriptionText={t('Seguimiento de envío')}
          orderNumber={`${t('Pedido')} ${context?.orderInfo?.orderNumber}`}
        />
        <Outlet />
      </Styles.ContentContainer>
      <Styles.FooterContainer>
        <Footer />
      </Styles.FooterContainer>
    </ThemeProvider>
  )
}

export default PageLayout
